"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_datepicker_1 = require("react-datepicker");
var ApplicationTable_1 = require("./ApplicationTable");
var RestUtilities_1 = require("../services/RestUtilities");
var ToastUtilities_1 = require("./ToastUtilities");
// https://github.com/Hacker0x01/react-datepicker
var AuthHome = /** @class */ (function (_super) {
    __extends(AuthHome, _super);
    function AuthHome(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSliderChangeUser = function (event, data) {
            _this.handleSliderChange(data.checked);
        };
        _this.handleSliderChange = function (checked) {
            _this.setState({
                sliderSetting: checked,
                allColor: checked ? "grey" : "green",
                customColor: checked ? "green" : "grey",
                filtersVisible: checked ? true : false
            }, function () {
                // If you go from 'Custom' to 'All' => Refresh
                if (!checked) {
                    _this.handleTableRefresh();
                }
            });
        };
        _this.handleStartDateChange = function (startdate) {
            if (_this.state.endDate < startdate) {
                ToastUtilities_1.default.error('The date you have selected is greater than the end date. Please choose a date after the end date.');
            }
            else {
                _this.setState({
                    startDate: startdate
                });
            }
        };
        _this.handleEndDateChange = function (enddate) {
            // Check if the start date is not less than the end date.
            if (_this.state.startDate > enddate) {
                ToastUtilities_1.default.error('The date you have selected is less than the start date. Please choose a date after the start date.');
            }
            else {
                _this.setState({
                    endDate: enddate
                });
            }
        };
        _this.handleTableRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var newTableItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newTableItems = { loading: true, applications: [] };
                        this.setState({ tableItems: newTableItems });
                        if (!(this.state.sliderSetting === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, RestUtilities_1.get("api/Application/GetUserApplicationsJsonDates?startDate=" + this.state.startDate.toISOString() + "&endDate=" + this.state.endDate.toISOString())
                                .then(function (response) {
                                newTableItems.loading = false;
                                if (!response.isError) {
                                    newTableItems.applications = response.content;
                                }
                                else {
                                    ToastUtilities_1.default.error(response.errorContent.errorMessage);
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, RestUtilities_1.get("api/Application/GetUserApplicationsJson")
                            .then(function (response) {
                            newTableItems.loading = false;
                            if (!response.isError) {
                                newTableItems.applications = response.content;
                            }
                            else {
                                ToastUtilities_1.default.error(response.errorContent.errorMessage);
                            }
                        })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        // Send the applications and turn off loading indicator
                        this.setState({ tableItems: newTableItems });
                        return [2 /*return*/];
                }
            });
        }); };
        // Set up intial dates
        var todaysDate = new Date();
        var previousDate = new Date();
        previousDate.setDate(todaysDate.getDate() - 30);
        // Declare a temp state
        var tmpState = {
            sliderSetting: false,
            startDate: previousDate,
            endDate: todaysDate,
            allColor: "grey",
            customColor: "green",
            filtersVisible: true,
            tableItems: { loading: false, applications: [] }
        };
        // If Admin, change some properties.
        if (_this.props.authUser.role === 'dco' || _this.props.authUser.role === 'administrator') {
            tmpState.sliderSetting = true;
            tmpState.allColor = "grey";
            tmpState.customColor = "green";
        }
        // Load the state
        _this.state = tmpState;
        return _this;
    }
    AuthHome.prototype.componentDidMount = function () {
        this.handleTableRefresh();
    };
    AuthHome.prototype.render = function () {
        var filtersVisible = this.state.filtersVisible;
        return (React.createElement(semantic_ui_react_1.Container, null,
            React.createElement(semantic_ui_react_1.Header, { key: "Header1", as: 'h2', content: this.props.authUser ? "User email: " + this.props.authUser.email : 'Choose one of the options below.', inverted: true, style: { fontSize: '1.7em', fontWeight: 'normal' } }),
            React.createElement(semantic_ui_react_1.Menu, { key: "SubMenubar" },
                React.createElement(semantic_ui_react_1.Menu.Item, { as: react_router_dom_1.Link, to: '/application', key: "MenuItem1" },
                    React.createElement(semantic_ui_react_1.Icon, { color: 'green', name: "plus circle", size: 'big' }),
                    "New Application"),
                (this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (React.createElement(semantic_ui_react_1.Menu.Item, { position: 'right', compact: "true", style: { zIndex: 1001 }, key: "MenuItem2" },
                    React.createElement(semantic_ui_react_1.Label, { color: this.state.allColor, style: { marginRight: 5 }, key: "AllLabel" }, "All"),
                    React.createElement(semantic_ui_react_1.Radio, { slider: true, fitted: true, checked: this.state.sliderSetting, onChange: this.handleSliderChangeUser, key: 'RadioSlider', disabled: this.state.tableItems.loading }),
                    React.createElement(semantic_ui_react_1.Label, { color: this.state.customColor, style: { marginLeft: 5, marginRight: 15 }, key: "CustomLabel" }, "Custom"),
                    React.createElement(semantic_ui_react_1.Transition.Group, { animation: "fade right", duration: "500", key: "animationGroup" }, filtersVisible && [
                        React.createElement(react_datepicker_1.default, { selected: this.state.startDate, onChange: this.handleStartDateChange, disabled: !this.state.sliderSetting, title: 'Start Date', key: 'StartDatePicker' }),
                        React.createElement(semantic_ui_react_1.Label, { style: { marginLeft: 3, marginRight: 3 } }, "-"),
                        React.createElement(react_datepicker_1.default, { selected: this.state.endDate, onChange: this.handleEndDateChange, disabled: !this.state.sliderSetting, title: 'End Date', key: 'EndDatePicker' }),
                        React.createElement(semantic_ui_react_1.Button, { compact: true, size: "small", style: { marginLeft: 5, marginRight: 5 }, onClick: this.handleTableRefresh },
                            React.createElement(semantic_ui_react_1.Button.Content, null,
                                React.createElement(semantic_ui_react_1.Icon, { name: "refresh" })))
                    ])))),
            React.createElement(semantic_ui_react_1.Segment, null,
                React.createElement(ApplicationTable_1.default, { authUser: this.props.authUser, loading: this.state.tableItems.loading, applications: this.state.tableItems.applications }))));
    };
    return AuthHome;
}(React.Component));
exports.default = AuthHome;
//# sourceMappingURL=AuthHome.js.map